import { projects as featuredRegistry } from './projects';
import { archiveProjects } from './archiveProjects';

export const WORK_FILTER_OPTIONS = [
  { id: 'all', label: 'ALL' },
  { id: 'visual', label: 'VISUAL' },
  { id: 'information', label: 'INFORMATION' },
  { id: 'web', label: 'WEB' },
];

const categoryBySlug = {
  'rain-alley': 'visual',
  wraith: 'visual',
  shelter: 'visual',
  'bar-scene': 'visual',
  dojaka: 'visual',
  'klm-board': 'information',
  'dior-board': 'information',
  'mismo-studio': 'web',
  mescalina: 'web',
};

const featuredMeta = {
  menya: 'F&B · Hybrid Content · 2026',
  nordvik: 'Cinematic LookDev · 2025',
  solitaire: 'Jewelry Rendering · 2025',
};

const categoryByIndex = {
  '01': 'visual',
  '02': 'visual',
  '03': 'visual',
  '04': 'visual',
  '05': 'visual',
  '06': 'visual',
  '07': 'visual',
  '08': 'visual',
  '09': 'information',
  '10': 'information',
  '11': 'web',
  '12': 'web',
};

const featuredEntries = featuredRegistry.map((p) => ({
  index: p.index,
  title: p.title,
  meta: featuredMeta[p.slug] || `${p.category} · ${p.year}`,
  image: p.media,
  path: p.path,
  category: categoryByIndex[p.index],
}));

const archiveEntries = archiveProjects.map((p) => ({
  index: p.index,
  title: p.title,
  meta: `${p.category} · ${p.year}`,
  image: p.heroImage,
  path: p.path,
  category: categoryBySlug[p.slug],
}));

/** Tutti i progetti in archive — unica sorgente per il marquee */
export const allWorks = [...featuredEntries, ...archiveEntries];

export const WORK_FILTER_COUNTS = allWorks.reduce(
  (acc, item) => {
    acc[item.category] = (acc[item.category] || 0) + 1;
    return acc;
  },
  { all: allWorks.length },
);

export const PRACTICE_START_YEAR = 2019;

export const getPracticeSpanYears = () => ({
  start: PRACTICE_START_YEAR,
  end: new Date().getFullYear(),
});

const getPracticeSpan = () => {
  const { start, end } = getPracticeSpanYears();
  return `${start} – ${end}`;
};

export const WORK_STATS = {
  total: allWorks.length,
  disciplines: 4,
  since: String(PRACTICE_START_YEAR),
  get span() {
    return getPracticeSpan();
  },
};
